import React, { Component } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

class Loading extends Component {
    render() {
        return (
            <Dimmer active>
                <Loader size={this.props.size} indeterminate>{this.props.indicator && this.props.indicator.length > 0 ? this.props.msg : "Loading"}..</Loader>
            </Dimmer>
        )
    }
}
export default Loading;


// WEBPACK FOOTER //
// ./src/app/ui/Loading.js